<template>
  <div ref="ShippingBillPdf" id="ShippingBillPdf">
    <CustomLoader v-if="isLoading" :width="70" />

    <b-card class="mainCardBG">
      <div class="gutr mt-3">
        <div class="row">
          <div class="col-xl-12 col-sm-12 grid-margin stretch-card">
            <div>
              <b-navbar toggleable="lg" type="dark" variant="info">
                <b-navbar-brand style="padding: 0.475rem 1rem">
                  <transition name="custom-slide" mode="out-in">
                    <h5> {{ $route.name }}</h5>
                  </transition>
                </b-navbar-brand>

                <b-navbar-nav class="ml-auto">
                  <b-nav-form>
                    <b-button-group size="sm" class="ml-1 text-right">
                      <b-button style="font-size: 0.675rem" variant="outline-secondary" @click="goBack">Back</b-button>
                    </b-button-group>
                  </b-nav-form>
                </b-navbar-nav>
              </b-navbar>

              <div>
                <b-card>
                  <b-row>
                    <b-col md="12">
                      <div class="tab-list d-flex">
                        <div v-for="(tab, index) in tabs" :key="index" :class="{ 'active-tab': activeTab === index }"
                          @click="changeTab(index)">
                          {{ tab.name }}
                        </div>
                      </div>

                      <transition name="custom-slide" mode="out-in">
                        <component :is="currentTabComponent" :key="activeTab"></component>
                      </transition>
                    </b-col>
                  </b-row>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";

import AllShippingBillList from "./shippingBillUpload.vue";
import AllLinkedShippingBillList from "./shippingBillUpload.vue";
import AllUnLinkedShippingBillList from "./shippingBillUpload.vue";

export default {
  beforeMount() {

    const loginId = this.$sessionsStorage.get("loginId");
    if (loginId) {
      if (globalPermissionStatus("Shipping Bill Mapper")) {
        this.$store.dispatch("setCurrentRoute", this.$route.path);
      } else {
        this.$router.push({ path: "/dashboard" });
      }
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({ path: "/Login/" });
    }
  },
  data() {
    return {
      activeTab: 0,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      tabs: [
        { name: "Un-Linked Shipping Bill List", component: AllUnLinkedShippingBillList },
        { name: "Linked Shipping Bill List", component: AllLinkedShippingBillList },
        { name: "All Shipping Bill List", component: AllShippingBillList },
      ],
      isLoading: false,
    };
  },
  components: {
    CustomLoader,
    DatePicker,
  },
  computed: {
    currentTabComponent() {
      return this.tabs[this.activeTab].component;
    },
  },
  methods: {
    changeTab(index) {
      localStorage.setItem("linkedSB", index);
      this.activeTab = index;
    },
    goBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style scoped>
.formCard {
  border: none !important;
  padding: 0;
}

.tab-list {
  display: flex;
  cursor: pointer;
  overflow-x: auto;
}

.tab-list div {
  padding: 5px;
  margin: 5px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  white-space: nowrap;
  user-select: none;
  transition: background-color 0.3s;
}

.tab-list div:hover {
  background-color: #0aa46e;
}

.active-tab {
  background-color: #007bff;
  color: #ffffff;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.custom-slide-enter-active,
.custom-slide-leave-active {
  transition: transform 0.5s;
}

.custom-slide-enter,
.custom-slide-leave-to {
  transform: translateX(100%);
}
</style>



// WEBPACK FOOTER //
// Tab.vue?3668482b